import { FC, MouseEvent, useState } from 'react';
import { createPortal } from 'react-dom';

import { ReportViewer } from '@jbc-year-end-adj/2024/features/reports/employee/components/ReportViewer';
import { ReportName } from '@jbc-year-end-adj/2024/features/reports/employee/types';

import { Report } from './Report';

// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup';

type ReportListProps = {
  needAdjThisYear: boolean;
  nextYearOnly: boolean;
  isNotCoveredByNextYear: boolean;
  isWithholdingSlipUnavailable: boolean;
};

export const ReportList: FC<ReportListProps> = ({
  needAdjThisYear,
  nextYearOnly,
  isNotCoveredByNextYear,
  isWithholdingSlipUnavailable
}) => {
  const [reportName, setReportName] = useState<ReportName>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  if (!needAdjThisYear && !nextYearOnly) return null;

  const handleClose = () => {
    setReportName(undefined);
    setIsOpen(false);
  };

  const handleOpenPdfViewer = (e: MouseEvent, name: ReportName) => {
    e.stopPropagation();
    setReportName(name);
    setIsOpen(true);
  };

  return (
    <>
      <ListGroup>
        {nextYearOnly ? (
          <ListGroup.Item as="a" onClick={(e: MouseEvent) => handleOpenPdfViewer(e, 'dependentDeductionNextYear')}>
            <Report reportName="dependentDeductionNextYear" />
          </ListGroup.Item>
        ) : (
          <>
            {!isWithholdingSlipUnavailable && (
              <ListGroup.Item as="a" onClick={(e: MouseEvent) => handleOpenPdfViewer(e, 'dependentDeductionThisYear')}>
                <Report reportName="dependentDeductionThisYear" />
              </ListGroup.Item>
            )}
            {!isNotCoveredByNextYear && (
              <ListGroup.Item as="a" onClick={(e: MouseEvent) => handleOpenPdfViewer(e, 'dependentDeductionNextYear')}>
                <Report reportName="dependentDeductionNextYear" />
              </ListGroup.Item>
            )}
            {!isWithholdingSlipUnavailable && (
              <>
                <ListGroup.Item as="a" onClick={(e: MouseEvent) => handleOpenPdfViewer(e, 'insuranceDeduction')}>
                  <Report reportName="insuranceDeduction" />
                </ListGroup.Item>
                <ListGroup.Item as="a" onClick={(e: MouseEvent) => handleOpenPdfViewer(e, 'bsiDeduction')}>
                  <Report reportName="bsiDeduction" />
                </ListGroup.Item>
              </>
            )}
          </>
        )}
      </ListGroup>
      {isOpen && reportName && createPortal(<ReportViewer reportName={reportName} onClose={() => handleClose()} />, document.body)}
    </>
  );
};
